<template>
  <div class="me-email-daily-body">
    <div class="me-email-daily-wrapper">
      <div class="me-email-daily-header">
        <div>
          <h1 class="me-email-daily-logo">
            <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogoMax" />
          </h1>
          <span v-show="!isWhitelabel() && !isMetrack()" class="me-email-daily-link">
            www.mceasy.com
          </span>
          <div class="me-email-daily-clearfix"></div>
        </div>
        <h4 class="me-email-daily-header-title">
          {{ $t('dashboard.scheduler.previewDaily.operationalSummary') }}
        </h4>
        <span class="me-email-daily-header-date">30 Maret 2024</span>
      </div>
      <div class="me-email-daily-list">
        <div class="me-email-daily-list-item">
          <p class="me-email-daily-list-item-title">
            {{ $t('dashboard.scheduler.previewDaily.utilityTitle') }}
          </p>
          <div>
            <div class="me-email-daily-list-item-left">
              <div>
                <div class="me-email-daily-list-item-left-count">
                  <h4 class="me-email-daily-list-item-left-count-index">132</h4>
                  <span class="me-email-daily-list-item-left-count-total"
                    >{{ $t('dashboard.scheduler.previewDaily.from') }} 150</span
                  >
                </div>
                <div class="me-email-daily-list-item-right-count">
                  <h4 class="me-email-daily-list-item-left-count-percent me-email-daily-green">
                    +32%
                  </h4>
                  <span class="me-email-daily-list-item-left-count-day">{{
                    $t('dashboard.scheduler.previewDaily.since')
                  }}</span>
                </div>
                <div class="me-email-daily-clearfix"></div>
              </div>
            </div>
            <div class="me-email-daily-list-item-right">
              <div>
                <div class="me-email-daily-list-item-bar">
                  <span class="me-email-daily-list-item-bar-chart-number">100</span>
                  <div class="me-email-daily-list-item-bar-chart" style="height: 100px"></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
                <div class="me-email-daily-list-item-bar">
                  <span class="me-email-daily-list-item-bar-chart-number">50</span>
                  <div class="me-email-daily-list-item-bar-chart" style="height: 50px"></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
                <div class="me-email-daily-list-item-bar">
                  <span class="me-email-daily-list-item-bar-chart-number">80</span>
                  <div class="me-email-daily-list-item-bar-chart" style="height: 80px"></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-list-item">
          <p class="me-email-daily-list-item-title">
            {{ $t('dashboard.scheduler.previewDaily.offlineVehicle') }}
          </p>
          <div>
            <div class="me-email-daily-list-item-left">
              <div>
                <div class="me-email-daily-list-item-left-count">
                  <h4
                    class="me-email-daily-list-item-left-count-index me-email-daily-list-item-left-count-index-navy"
                  >
                    5
                  </h4>
                  <span class="me-email-daily-list-item-left-count-total"
                    >{{ $t('dashboard.scheduler.previewDaily.from') }} 150</span
                  >
                </div>
                <div class="me-email-daily-list-item-right-count">
                  <h4 class="me-email-daily-list-item-left-count-percent me-email-daily-red">
                    +32%
                  </h4>
                  <span class="me-email-daily-list-item-left-count-day">{{
                    $t('dashboard.scheduler.previewDaily.since')
                  }}</span>
                </div>
                <div class="me-email-daily-clearfix"></div>
              </div>
            </div>
            <div class="me-email-daily-list-item-right">
              <div>
                <div class="me-email-daily-list-item-bar">
                  <span
                    class="me-email-daily-list-item-bar-chart-number me-email-daily-list-item-bar-chart-number-navy"
                    >100</span
                  >
                  <div
                    class="me-email-daily-list-item-bar-chart me-email-daily-list-item-bar-chart-navy"
                    style="height: 100px"
                  ></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
                <div class="me-email-daily-list-item-bar">
                  <span
                    class="me-email-daily-list-item-bar-chart-number me-email-daily-list-item-bar-chart-number-navy"
                    >50</span
                  >
                  <div
                    class="me-email-daily-list-item-bar-chart me-email-daily-list-item-bar-chart-navy"
                    style="height: 50px"
                  ></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
                <div class="me-email-daily-list-item-bar">
                  <span
                    class="me-email-daily-list-item-bar-chart-number me-email-daily-list-item-bar-chart-number-navy"
                    >80</span
                  >
                  <div
                    class="me-email-daily-list-item-bar-chart me-email-daily-list-item-bar-chart-navy"
                    style="height: 80px"
                  ></div>
                  <span class="me-email-daily-list-item-bar-chart-date">28 Mar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="me-email-daily-list-two">
        <div class="me-email-daily-list-two-item">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-first"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">
                5 {{ $t('dashboard.scheduler.previewDaily.silentVehicle') }}
              </h4>
              <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <table width="100%">
                <tr>
                  <th height="30" align="left">#</th>
                  <th align="right">
                    {{ $t('dashboard.scheduler.previewDaily.totalDuration') }}
                  </th>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
              </table>
              <div class="me-email-daily-alert">
                {{ $t('dashboard.scheduler.previewDaily.enableSilince') }}
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-list-two-item">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-last"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">
                5 {{ $t('dashboard.scheduler.previewDaily.oftenVisited') }}
              </h4>
              <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <table width="100%">
                <tr>
                  <th height="30" align="left">#</th>
                  <th align="right">
                    {{ $t('dashboard.scheduler.previewDaily.totalDuration') }}
                  </th>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
              </table>
              <div class="me-email-daily-alert">
                {{ $t('dashboard.scheduler.previewDaily.monitorReport') }}
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-list-two-item me-email-daily-list-two-item-last">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-first"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">
                5 {{ $t('dashboard.scheduler.previewDaily.distanceVehicle') }}
              </h4>
              <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <table width="100%">
                <tr>
                  <th height="30" align="left">#</th>
                  <th align="right">
                    {{ $t('dashboard.scheduler.previewDaily.totalDuration') }}
                  </th>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
              </table>
              <div class="me-email-daily-alert">
                {{ $t('dashboard.scheduler.previewDaily.liveViewFeature') }}
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-list-two-item me-email-daily-list-two-item-last">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-last"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">
                5 {{ $t('dashboard.scheduler.previewDaily.drivingDuration') }}
              </h4>
              <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <table width="100%">
                <tr>
                  <th height="30" align="left">#</th>
                  <th align="right">
                    {{ $t('dashboard.scheduler.previewDaily.totalDuration') }}
                  </th>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
                <tr>
                  <td height="30">B 1234 WW</td>
                  <td align="right">1 Jam 10 Menit</td>
                </tr>
              </table>
              <div class="me-email-daily-alert">
                {{ $t('dashboard.scheduler.previewDaily.vehicleMangement') }}
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-clearfix"></div>
      </div>
      <div class="me-email-daily-total-alert">
        <div class="me-email-daily-list-two-item-header">
          <h4 class="me-email-daily-list-two-item-header-title">
            {{ $t('dashboard.scheduler.previewDaily.totalWarning') }}
          </h4>
          <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
        </div>
        <div class="me-email-daily-total-alert-body">
          <div class="me-email-daily-total-alert-list">
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-inline"
            >
              <h4 class="me-email-daily-total-alert-list-item-count">5</h4>
              <span class="me-email-daily-total-alert-list-item-desc">
                {{ $t('dashboard.scheduler.previewDaily.sosButton') }}</span
              >
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-inline"
            >
              <h4 class="me-email-daily-total-alert-list-item-count">5</h4>
              <span class="me-email-daily-total-alert-list-item-desc">{{
                $t('dashboard.scheduler.previewDaily.gpsRelease')
              }}</span>
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-inline"
            >
              <h4 class="me-email-daily-total-alert-list-item-count">5</h4>
              <span class="me-email-daily-total-alert-list-item-desc">{{
                $t('dashboard.scheduler.previewDaily.gpsSignal')
              }}</span>
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-inline"
            >
              <h4 class="me-email-daily-total-alert-list-item-count">5</h4>
              <span class="me-email-daily-total-alert-list-item-desc">{{
                $t('dashboard.scheduler.previewDaily.parkingTime')
              }}</span>
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-inline"
            >
              <h4 class="me-email-daily-total-alert-list-item-count">5</h4>
              <span class="me-email-daily-total-alert-list-item-desc">{{
                $t('dashboard.scheduler.previewDaily.idleTime')
              }}</span>
            </div>
            <div class="me-email-daily-clearfix"></div>
          </div>
        </div>
      </div>
      <div class="me-email-daily-total-alert me-email-daily-total-alert-last">
        <div class="me-email-daily-list-two-item-header">
          <h4 class="me-email-daily-list-two-item-header-title">
            5 {{ $t('dashboard.scheduler.previewDaily.latestWarning') }}
          </h4>
          <span class="me-email-daily-list-two-item-header-date">30 Maret 2024</span>
        </div>
        <div class="me-email-daily-total-alert-body">
          <table width="100%">
            <tr>
              <th height="30" width="28%" align="left">#</th>
              <th height="30" width="30%" align="left">
                {{ $t('dashboard.scheduler.previewDaily.time') }}
              </th>
              <th height="30" width="42%" align="left">
                {{ $t('dashboard.scheduler.previewDaily.notification') }}
              </th>
            </tr>
            <tr>
              <td height="40" valign="top">B 1234 WW</td>
              <td height="40" valign="top">
                30 Maret 2024<span class="me-email-daily-gray">16:00</span>
              </td>
              <td height="40" valign="top">Pelepasan Perangkat</td>
            </tr>
            <tr>
              <td height="40" valign="top">B 1234 WW</td>
              <td height="40" valign="top">
                30 Maret 2024<span class="me-email-daily-gray">16:00</span>
              </td>
              <td height="40" valign="top">Pelepasan Perangkat</td>
            </tr>
            <tr>
              <td height="40" valign="top">B 1234 WW</td>
              <td height="40" valign="top">
                30 Maret 2024<span class="me-email-daily-gray">16:00</span>
              </td>
              <td height="40" valign="top">Pelepasan Perangkat</td>
            </tr>
            <tr>
              <td height="40" valign="top">B 1234 WW</td>
              <td height="40" valign="top">
                30 Maret 2024<span class="me-email-daily-gray">16:00</span>
              </td>
              <td height="40" valign="top">Pelepasan Perangkat</td>
            </tr>
            <tr>
              <td height="40" valign="top">B 1234 WW</td>
              <td height="40" valign="top">
                30 Maret 2024<span class="me-email-daily-gray">16:00</span>
              </td>
              <td height="40" valign="top">Pelepasan Perangkat</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="me-email-daily-list-two">
        <div class="me-email-daily-list-two-item">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-first"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">
                {{ $t('dashboard.scheduler.previewDaily.vehicleLicense') }}
              </h4>
              <span class="me-email-daily-list-two-item-header-date">{{
                $t('dashboard.scheduler.previewDaily.atTheMoment')
              }}</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <div class="me-email-daily-total-alert-list">
                <div
                  class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-half"
                >
                  <h4
                    class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
                  >
                    5
                  </h4>
                  <span class="me-email-daily-status me-email-daily-status--yellow">{{
                    $t('dashboard.scheduler.previewDaily.status.willExpire')
                  }}</span>
                </div>
                <div
                  class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-half"
                >
                  <h4
                    class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
                  >
                    5
                  </h4>
                  <span class="me-email-daily-status me-email-daily-status--red">{{
                    $t('dashboard.scheduler.previewDaily.status.expired')
                  }}</span>
                </div>
                <div class="me-email-daily-clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-list-two-item">
          <div
            class="me-email-daily-list-two-item-wrapper me-email-daily-list-two-item-wrapper-last"
          >
            <div class="me-email-daily-list-two-item-header">
              <h4 class="me-email-daily-list-two-item-header-title">Lisensi Pengemudi</h4>
              <span class="me-email-daily-list-two-item-header-date">Saat ini</span>
            </div>
            <div class="me-email-daily-list-two-item-body">
              <div class="me-email-daily-total-alert-list">
                <div
                  class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-half"
                >
                  <h4
                    class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
                  >
                    5
                  </h4>
                  <span class="me-email-daily-status me-email-daily-status--yellow">{{
                    $t('dashboard.scheduler.previewDaily.status.willExpire')
                  }}</span>
                </div>
                <div
                  class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-half"
                >
                  <h4
                    class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
                  >
                    5
                  </h4>
                  <span class="me-email-daily-status me-email-daily-status--red">{{
                    $t('dashboard.scheduler.previewDaily.status.expired')
                  }}</span>
                </div>
                <div class="me-email-daily-clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="me-email-daily-clearfix"></div>
      </div>
      <div class="me-email-daily-total-alert">
        <div class="me-email-daily-list-two-item-header">
          <h4 class="me-email-daily-list-two-item-header-title">
            {{ $t('dashboard.scheduler.previewDaily.serviceStatus') }}
          </h4>
          <span class="me-email-daily-list-two-item-header-date">{{
            $t('dashboard.scheduler.previewDaily.atTheMoment')
          }}</span>
        </div>
        <div class="me-email-daily-total-alert-body">
          <div class="me-email-daily-total-alert-list">
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-third"
            >
              <h4
                class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
              >
                5
              </h4>
              <span class="me-email-daily-status me-email-daily-status--yellow">{{
                $t('dashboard.scheduler.previewDaily.status.willExpire')
              }}</span>
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-third"
            >
              <h4
                class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
              >
                5
              </h4>
              <span class="me-email-daily-status me-email-daily-status--red">{{
                $t('dashboard.scheduler.previewDaily.status.expired')
              }}</span>
            </div>
            <div
              class="me-email-daily-total-alert-list-item me-email-daily-total-alert-list-item-third"
            >
              <h4
                class="me-email-daily-total-alert-list-item-count me-email-daily-total-alert-list-item-count-navy"
              >
                5
              </h4>
              <span class="me-email-daily-status me-email-daily-status--blue">{{
                $t('dashboard.scheduler.previewDaily.status.underService')
              }}</span>
            </div>
            <div class="me-email-daily-clearfix"></div>
          </div>
        </div>
      </div>
      <div class="me-email-daily-footer" v-show="!isWhitelabel() && !isMetrack()">
        <table width="100%">
          <tr>
            <td colspan="2" align="center">
              <table align="center" width="100%">
                <tr>
                  <td align="center">
                    <h4
                      style="
                        font-size: 16px;
                        margin: 0;
                        color: #01133d;
                        font-weight: 500;
                        line-height: 1.8;
                      "
                    >
                      {{ $t('dashboard.scheduler.previewDaily.footer.text') }} <br />{{
                        $t('dashboard.scheduler.previewDaily.footer.text2')
                      }}
                      <a
                        href="https://wa.me/6281233504586"
                        target="_blank"
                        style="color: #0d4491; text-decoration: underline"
                        >{{ $t('dashboard.scheduler.previewDaily.footer.inHere') }}</a
                      >
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td height="20">&nbsp;</td>
                </tr>
                <tr>
                  <td align="center">
                    {{ $t('dashboard.scheduler.previewDaily.footer.follow') }}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td align="center">
                    <a
                      href="https://www.facebook.com/mceasy.id"
                      target="_blank"
                      style="text-decoration: none; margin-right: 15px"
                    >
                      <img
                        style="border-radius: 5px"
                        alt="Facebook"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_facebook_square.png"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/mceasy/"
                      target="_blank"
                      style="text-decoration: none; margin-right: 15px"
                    >
                      <img
                        style="border-radius: 5px"
                        alt="Linkedin"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_linked_in_square.png"
                      />
                    </a>

                    <a
                      href="https://www.youtube.com/@McEasy"
                      target="_blank"
                      style="text-decoration: none; margin-right: 15px"
                    >
                      <img
                        style="border-radius: 5px"
                        alt="Youtube"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_youtube_square.png"
                      />
                    </a>

                    <a
                      href="https://www.instagram.com/mceasy.id/"
                      target="_blank"
                      style="text-decoration: none"
                    >
                      <img
                        style="border-radius: 5px"
                        alt="Instagram"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_instagram_square.png"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td height="20">&nbsp;</td>
                </tr>
                <tr>
                  <td align="center">
                    {{ $t('dashboard.scheduler.previewDaily.footer.download') }}
                  </td>
                </tr>
                <tr>
                  <td height="10">&nbsp;</td>
                </tr>
                <tr>
                  <td align="center">
                    <a
                      href="https://apps.apple.com/id/app/mceasy-platform/id6450102428"
                      target="_blank"
                      class="me-email-daily-logo-download me-email-daily-logo-download-first"
                    >
                      <img
                        alt="App Store"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_download_appstore.png"
                        class="me-email-daily-logo-download-img"
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.mceasy.vsms&pcampaignid=web_share"
                      target="_blank"
                      class="me-email-daily-logo-download"
                    >
                      <img
                        alt="Google Play"
                        class="me-email-daily-logo-download-img"
                        src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_download_googleplay.png"
                      />
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
  
  <script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getAsset: 'asset/getAsset',
    }),
  },
}
</script>
  
  <style lang="scss" scoped>
@import './digest.scss';
</style>
  